import axios, { AxiosRequestConfig } from 'axios'
import { ReadTradableInstrumentsRequestDto, ReadTradableInstrumentsResponseDto } from '@sparling/financial-common'

export const getTradableInstruments = async (
  { token }: ReadTradableInstrumentsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadTradableInstrumentsResponseDto> => {
  const response = await axios.get(`${process.env.REACT_APP_REST_API_URL}/trading/instruments`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      Pragma: 'no-cache',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      ...options.headers,
    },
  })
  return response.data
}
